import { Box, Typography } from '@mui/material';
import { NavLink } from 'react-router';
import { tokens } from '../../theme';
import type { AdminNavProps } from './types';

/**
 * The tabs between the admin pages. **Real links, one per page**, so each page has an
 * address that can be shared and the back button moves between them.
 *
 * Active when the path is the tab's own or inside it, which is what `NavLink` does by
 * default, and it sets `aria-current="page"` itself.
 */
export const AdminNav = ({ items }: AdminNavProps) => (
  <Box component="nav" aria-label="Admin" sx={{ display: 'flex', flexWrap: 'wrap', gap: 4, borderBottom: 1, borderColor: 'border.default' }}>
    {items.map((item) => (
      <NavLink key={item.to} to={item.to} style={{ textDecoration: 'none', color: 'inherit' }}>
        {({ isActive }) => (
          <Typography
            variant="body2"
            component="span"
            sx={{
              position: 'relative',
              display: 'inline-block',
              paddingInline: 2,
              paddingBlock: 2,
              borderRadius: `${String(tokens.radius.md)}px`,
              whiteSpace: 'nowrap',
              color: isActive ? 'text.primary' : 'text.secondary',
              fontWeight: isActive ? 500 : 400,
              '&:hover': { color: 'text.primary', backgroundColor: 'surface.sunken' },
              // Under the label, on the nav's own rule, so the active tab reads as the one you are on.
              '&::after': isActive
                ? { content: '""', position: 'absolute', left: 8, right: 8, bottom: -1, height: 2, backgroundColor: 'primary.main' }
                : undefined,
            }}
          >
            {item.label}
          </Typography>
        )}
      </NavLink>
    ))}
  </Box>
);
